import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRefreshTableOnFilterChange } from '../common/decorators';
import history from '../../../history';
import { fetchSeries, setSelectedSeries } from '../../../actions/Series';
import SeriesTable from './SeriesTable';
import { TDispatch, TRootState } from '../../../reducers';
import { TMeta, TPageNotification, TSeries, TUser, TWorkerItem } from '../../../types';
import actions from '../../../actions';


type TSeriesManagementProps = {
    user: TUser;
    meta: TMeta;
    content: TSeries[];
    fetching: boolean;
    notification: TPageNotification;
    load: (searchParams: URLSearchParams) => void;
    currentPage: number;
    onFilterChange: () => void;
    onPageChange: () => void;
    searchValue: string;
    selectedSeries: TSeries,
    selectedFreelancers: TWorkerItem[];
    setSelectedSeries: (item: TSeries) => void;
    setSelectedFreelancers: (item: any[]) => void;
}


// @ts-ignore
@withRefreshTableOnFilterChange
class SeriesManagement extends Component<TSeriesManagementProps> {
    componentDidMount() {
        const currentUrlParams = new URLSearchParams(history.location.search);
        this.props.load(currentUrlParams);
    }

    render() {
        const pages = this.props.meta ? Math.ceil(this.props.meta.count / 20) : -1;
        const showPaginationBottom = this.props.meta ? this.props.meta.count > 20 : false;

        const data: TSeries[] = this.props.content ? this.props.content : [];
        const currentUrlParams = new URLSearchParams(history.location.search);

        return (
            <SeriesTable
                user={this.props.user}
                meta={this.props.meta}
                data={data}
                pages={pages}
                showPaginationBottom={showPaginationBottom}
                loading={this.props.fetching}
                notification={this.props.notification}
                reloadData={() => {
                    this.props.load(currentUrlParams);
                }}
                currentPage={this.props.currentPage}
                onPageChange={this.props.onPageChange}
                onFilterChange={this.props.onFilterChange}
                searchValue={this.props.searchValue}
                selectedSeries={this.props.selectedSeries}
                selectedFreelancers={this.props.selectedFreelancers}
                setSelectedSeries={this.props.setSelectedSeries}
                setSelectedFreelancers={this.props.setSelectedFreelancers}
            />
        );
    }
}

const mapStateToProps = (state: TRootState) => ({
    ...state.series,
    user: state.user,
    selectedSeries: state.series.selectedSeries,
    selectedFreelancers: state.freelancers.selectedFreelancers,
});

const mapDispatchToProps = (dispatch: TDispatch) => ({
    load: (searchParams: URLSearchParams) => dispatch(fetchSeries(searchParams)),
    setSelectedSeries: (item: TSeries) => dispatch(setSelectedSeries(item)),
    setSelectedFreelancers: (items: any[]) => dispatch(actions.setSelectedFreelancers(items)),
});

export default connect(
    mapStateToProps, mapDispatchToProps,
)(SeriesManagement);
